export const FailedUpload = () => {
	return (
		<svg width="4" height="23" viewBox="0 0 4 23" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M2 1.00039L2 13.4004" stroke="#EC404C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<circle cx="2" cy="21" r="1.5" fill="#EC404C" />
		</svg>
	)
}
